<div class="px-5 d-flex flex-column" style="max-width: 580px;">
    <h3 mat-dialog-title class="mt-5">¿Por qué es necesario sincronizar tu cuenta SII?</h3>
    <div mat-dialog-content>
      <p>Al Sincronizar tu cuenta del SII, podremos ver las facturas de compra y de venta, CTE y datos generales de tu cuenta para evaluar tu negocio, así como también tu información en la TGR.
        <br>
        Ten en cuenta que no podremos realizar acciones en tu nombre solo obtener información para poder evaluarte.</p>
    </div>
    <h3 mat-dialog-title>¿Es seguro?</h3>
    <div mat-dialog-content>
      <p>Contamos con las mejores herramientas de seguridad que nos permiten consultar tus datos con máxima confidencialidad e integridad.</p>
    </div>
    <h3 mat-dialog-title>¿Para que se usa la Clave?</h3>
    <div mat-dialog-content>
      <p>La clave de consulta del SII nos permite acceder a tu información tributaria en tiempo real y analizar tus cuentas por cobrar y por pagar. Esta clave no nos permite ejecutar cambios dentro de tu cuenta, sólo observar la información. Gracias a esto, podemos brindarte nuestros servicios de forma más eficiente, obteniendo la información necesaria para evaluar tus operaciones de manera automática.</p>
    </div>
    <div mat-dialog-actions class="mb-5 mt-3 align-self-center">
        <button (click)="onClose()" type="button" class="btn btn-primary">Ok</button>
    </div>
</div>
